import { getPages, getPage } from "~/services/public/Pages"

export const state = (): PagesState => ({
  nodes: [],
  breadcrumbs: [],
  pageInfo: {
    endCursor: "",
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: ""
  },
  page: {
    id: "",
    slug: "",
    title: "",
    template: {
      templateName: ""
    },
    frontendUrl: "",
    content: "",
    blocks: [],
    excerpt: "",
    location: {
      locationIdentifier: "",
      locationDisplayName: "",
      mapPinsLatitude: "",
      mapPinsLongitude: "",
      mapPinsStars: "",
      mapPinsTextLine1: "",
      mapPinsTextLine2: "",
      mapPinsTextLine3: "",
      mapPinsImageIDs: "",
      summarySavings: "",
      summaryLocalExperts: "",
      summaryNeighboursMoved: "",
      summaryHeading: "",
      summaryUsp1: "",
      summaryUsp1Emoji: "",
      summaryUsp2: "",
      summaryUsp2Emoji: "",
      summaryUsp3: "",
      summaryUsp3Emoji: ""
    },
    pageInternalReviews: {
      count: 0,
      name: "",
      location: "",
      rating: "",
      review: "",
      type: "",
      typeEmoji: "",
      date: ""
    },
    uri: "",
    status: "",
    seo: {
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
      canonical: "",
      metaDesc: "",
      opengraphTitle: "",
      opengraphType: "",
      opengraphUrl: "",
      opengraphDescription: "",
      opengraphSiteName: "",
      opengraphImage: {},
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: {},
      breadcrumbs: []
    },
    featuredImage: {},
    pageFolders: {},
    locationForm: {},
    internalReviews: {},
    customPhoneNumber: "",
    language: {
      code: "EN"
    }
  },
  inventory: undefined, // undefined = no Location Form, null = Location Form loading, true/false = inventory on/off
  inventoryDesktop: undefined, // undefined = no Location Form, null = Location Form Extension loading, true/false = inventory desktop on/off
  windowWidth: undefined
})

export const GET_NODES = "getNodes"
export const GET_PAGE = "getPage"
export const GET_PAGE_INFO = "getPageInfo"
export const GET_BREADCRUMBS = "getBreadcrumbs"
export const GET_INVENTORY = "getInventory"
export const GET_INVENTORY_DESKTOP = "getInventoryDesktop"
export const GET_WINDOW_WIDTH = "getWindowWidth"
export const GET_IS_SMALL_OR_MEDIUM = "getIsSmallOrMedium"
export const GET_IS_EXTRA_LARGE = "getIsExtraLarge"

export const getters = {
  [GET_NODES]: state => state.nodes,
  [GET_PAGE]: state => state.page,
  [GET_PAGE_INFO]: state => state.pageInfo,
  [GET_BREADCRUMBS]: state => state.breadcrumbs,
  [GET_INVENTORY]: state => state.inventory,
  [GET_INVENTORY_DESKTOP]: state => state.inventoryDesktop,
  [GET_WINDOW_WIDTH]: state => state.windowWidth,
  [GET_IS_SMALL_OR_MEDIUM]: state =>
    state.windowWidth === undefined || (state.windowWidth && state.windowWidth < 992),
  [GET_IS_EXTRA_LARGE]: state => state.windowWidth && state.windowWidth >= 1200
}

export const _SET_NODES = "setNodes"
export const _SET_PAGE = "setPage"
export const _SET_PAGE_INFO = "setPageInfo"
export const _SET_BREADCRUMBS = "setBreadcrumbs"
export const _SET_INVENTORY = "setInventory"
export const _SET_INVENTORY_DESKTOP = "setInventoryDesktop"
export const _WINDOW_WIDTH = "setWindowWidth"

export const mutations = {
  [_SET_NODES](state, edges) {
    edges.forEach((edge, idx) => {
      state.nodes[idx] = edge.node
    })
  },

  [_SET_PAGE](state, page) {
    state.page = page
  },

  [_SET_PAGE_INFO](state, pageInfo) {
    state.pageInfo = pageInfo
  },

  [_SET_BREADCRUMBS](state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },

  [_SET_INVENTORY](state, inventory) {
    state.inventory = inventory
  },

  [_SET_INVENTORY_DESKTOP](state, inventoryDesktop) {
    state.inventoryDesktop = inventoryDesktop
  },

  [_WINDOW_WIDTH](state, windowWidth) {
    state.windowWidth = windowWidth
  }
}

export const SET_BREADCRUMBS = "setBreadcrumbs"
export const SET_INVENTORY = "setInventory"
export const SET_INVENTORY_DESKTOP = "setInventoryDesktop"
export const SET_WINDOW_WIDTH = "setWindowWidth"

export const actions = {
  [SET_BREADCRUMBS]({ commit }, data) {
    try {
      commit(_SET_BREADCRUMBS, data.breadcrumbs)

      return true
    } catch (err) {
      console.log(err)
      return err
    }
  },

  [SET_INVENTORY]({ commit }, inventory: boolean | null) {
    commit(_SET_INVENTORY, inventory)
  },

  [SET_INVENTORY_DESKTOP]({ commit }, inventoryDesktop: boolean | null) {
    commit(_SET_INVENTORY_DESKTOP, inventoryDesktop)
  },

  [SET_WINDOW_WIDTH]({ commit }, windowWidth: number) {
    commit(SET_WINDOW_WIDTH, windowWidth)
  }
}
